<template>
  <div class="home">
     <App-navigation></App-navigation>
     <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">
              Available refreshments
                           </v-flex>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>

            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-3" >
              <v-data-table :headers="headers" :items="loads()" :search="search" :custom-filter="customFilter" hide-actions class="elevation-1">
                <template slot="items" slot-scope="{item}">
                  <td><b>{{item.sn}}</b></td>
                  <td class="text-xs-center">{{item.name.toUpperCase()}}</td>
                  <td class="text-xs-center">{{item.price}}</td>
                  <td class="text-xs-center">{{item.useradd ? item.useradd : item.useredit }}</td>
                  <td class="justify-center layout px-0">
                     <Sell-refreshment v-if="crc(staff.rights,'010')" :price="item.price" :name="item.name" ></Sell-refreshment>
                    
                    <Edit-refreshment v-if="crc(staff.rights,'009')" :price="item.price" :name="item.name" ></Edit-refreshment>
                    <Delete-refreshment  v-if="crc(staff.rights,'011')" :name="item.name"></Delete-refreshment>
                  </td>
                </template>
              </v-data-table>

            </v-flex>
        </v-layout>
     </v-container>
     
     <Add-Refreshment v-if="crc(staff.rights,'008')"></Add-Refreshment>
  </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/Navigation/AppNavigation.vue'
import AddRefreshment from '@/components/Refreshment/AddRefreshment.vue'
import EditRefreshment from '@/components/Refreshment/EditRefreshment.vue'
import DeleteRefreshment from '@/components/Refreshment/DeleteRefreshment.vue'
import SellRefreshment from '@/components/Refreshment/SellRefreshment.vue'

import {checkright} from '@/validator'
export default {
  name: 'staff',
  data(){
      return {
         // staff:{name:'Okoedo',gender:''},
          staff:this.$store.getters.getStaff,
          dialog:false,
          search:'',
          headers:[
            { 
              text:'S/N',
              align:'center',
              sortable:true,
              value:'sn'
            },
            {
              text:'NAME',
              align:'center',
              sortable:true,
              value:'name'
            },
            {
              text:'PRICE',
              align:'center',
              sortable:true,
              value:'price'
            },
            {
              text:'ADDED BY/EDITED BY',
              align:'center',
              sortable:true,
              value:'useradd'
            },
            {
              text:'ACTION',
              sortable:false,
              value:'name'
            }
          ],
          listPrimitive:null
      }
  },
  methods:{
         loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateRefreshments');
            value = self.$store.getters.getRefreshment;
            //console.log(value);
            return value;
           
            
        },
    crc(array,value){
      return checkright(array,value);
    },
    customFilter(items,search){

     if(!search){ return items }
     function new_filter(val,search){
       return val !== null &&
        ['undefined','boolean'].indexOf(typeof val) === -1 &&
        val.toString().toLowerCase().replace( /[^0-9a-zA-Z]+/g ,'').indexOf(search) !== -1
     }

     let needleAry = search.toString().toLowerCase().split(" ").filter(x => x);

     return items.filter(row => needleAry.every(needle => Object.keys(row).some(key => new_filter(row[key],needle))));
    }
  },
  components: {
    AppNavigation,
    AddRefreshment,
    EditRefreshment,
    DeleteRefreshment,
    SellRefreshment,
  }
}
</script>
